import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text = '¡SÍ, QUIERO LIMPIAR MI CRÉDITO AHORA!',
  className = '',
  onClick
}) => {
  return <motion.button whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} onClick={() => {
    trackAddToCart();
    if (onClick) {
      onClick();
    } else {
      window.open('https://webdealzshoppersave.com/cart/48207177646336:1', '_blank');
    }
  }} className={`w-full sm:w-auto bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold text-lg md:text-xl py-4 px-8 rounded-lg shadow-[0_0_25px_rgba(201,168,76,0.25)] transition-colors duration-300 flex items-center justify-center text-center leading-tight cursor-pointer ${className}`} data-id="element-13">
      {text}
    </motion.button>;
};